import { toDatetime, toDate } from '@utils/date';
import { toNumber, toCurrency, toPercentage } from '@utils/number';

export default {
    methods: {
        toNumber,
        toCurrency,
        toPercentage,
        toDatetime,
        toDate
    }
};
